import { useState } from 'react';
import { TextField, Button } from '@mui/material';
import axios from 'axios';

export default function QrForm({
  qrCode,
  onSuccess,
  firebaseUser,
  setLoading,
  selectedStore = 1,
}) {
  const [tableNumber, setTableNumber] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!qrCode || !tableNumber) return;
    setSubmitting(true);
    setLoading(true);
    try {
      const idToken = await firebaseUser.getIdToken();

      await axios.post(
        '/hd-api/herd-serve',
        {
          QRCodeID: qrCode,
          TableNumber: tableNumber,
          StoreSkey: selectedStore,
        },
        {
          headers: {
            Authorization: `Bearer ${idToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setTableNumber('');
      onSuccess();
    } catch (error) {
      console.error('Failed to save mapping:', error);
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label='Table Number'
        value={tableNumber}
        onChange={(e) => setTableNumber(e.target.value)}
        required
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label='QR Code ID'
        value={qrCode || ''}
        disabled
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button type='submit' variant='contained' fullWidth>
        {submitting ? 'Saving...' : 'Save Mapping'}
      </Button>
    </form>
  );
}
